<template>
  <section class="activity-list">
    <Header />
    <div class="activity-list-wrapper">
      <ul class="activities">
        <li v-for="activity in $store.state.availableActivities" :key="activity.activity_id" class="activity-item">
          <a class="activity-link" :href="`#/plenaria/${activity.activity_id}`">{{ activity.activity }}</a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';

export default {
  name: 'ActivityList',

  components: {
    Header,
  },
};
</script>

<style lang="scss">
.activity-list {
  background-color: #01ace4;
  height: 100dvh;
}
.activity-list-wrapper {
  background-color: #01ace4;

  padding-top: 140px;
  padding-bottom: 140px;
  display: flex;
  justify-content: center;
}

.activities {
  position: relative;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.activity-item {
  position: relative;
  list-style: none;
  margin-right: 15px;

  &:last-child {
    margin-right: 0;
  }
}

.activity-link {
  position: relative;
  display: block;
  color: #00a4e0;
  font-size: 1.2vw;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0 40px;
  margin: 0;
  border-radius: var(--input-borderRadius);
  background-color: #fff;
  color: #01ace4;
}
</style>
